import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Validation = (props) => (
  <Icon viewBox="0 20 2 11" {...props}>
    <g>
      <title>!</title>
      <path id="Fill-2" d="M1 27c-.6 0-1-.4-1-1v-5c0-.6.4-1 1-1s1 .4 1 1v5c0 .6-.4 1-1 1zm0 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1z" className="st0"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Validation;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Validation.js